import EditButtons from './EditButtons';

export default EditButtons;
